<template>
  <page-layout :avatar="basicInfo.avatar">
    <template v-if="isAdministrator">
      <template slot="headerContent">
        <div class="user-info">
          <div class="avatar-wrapper">
            <a-avatar :size="80" :src="basicInfo.avatar || defaultAvatarImg"></a-avatar>
          </div>
          <div class="info">
            <div class="name">您好，{{ basicInfo.name }}</div>
            <div
              class="role"
            >{{ basicInfo.post }} | {{ basicInfo.college.name }} - {{ basicInfo.departments && basicInfo.departments.join(' - ') }}</div>
          </div>
        </div>
      </template>
      <template slot="extra">
        <a-row class="more-info">
          <a-col :span="6">
            <head-info
              title="发起的项目"
              :content="basicInfo.projectsCount"
              :center="false"
              :bordered="false"
            />
            <!-- <div class="item">
              <div class="num">{{ basicInfo.projectsCount }}</div>
              <div class="label">发起的项目</div>
            </div>-->
          </a-col>
          <a-col :span="6">
            <head-info
              title="参与的项目"
              :content="basicInfo.participatedProjectsCount"
              :center="false"
              :bordered="false"
            />
            <!-- <div class="item">
              <div class="num">{{ basicInfo.participatedProjectsCount }}</div>
              <div class="label">参与的项目</div>
            </div>-->
          </a-col>
          <a-col :span="6">
            <head-info
              title="申请中的项目"
              :content="basicInfo.applicationsCount"
              :center="false"
              :bordered="false"
            />
            <!-- <div class="item">
              <div class="num">{{ basicInfo.applicationsCount }}</div>
              <div class="label">申请中的项目</div>
            </div>-->
          </a-col>
          <a-col :span="6" style="padding-top: 15px">
            <CreateProjectModal>
              <a-button type="primary" size="large" block>发起新项目</a-button>
            </CreateProjectModal>
          </a-col>
        </a-row>
      </template>
      <a-row>
        <a-col :xs="12" :lg="12" :xl="8" :xxl="8"></a-col>
        <a-col :xs="12" :lg="12" :xl="16" :xxl="16"></a-col>
      </a-row>
    </template>
    <slot></slot>
  </page-layout>
</template>

<script>
import { mapState } from 'vuex'
import { mixin } from '@/utils/mixin'
import PageLayout from '@/components/page/PageLayout'
import HeadInfo from '@/components/tools/HeadInfo'
import { CreateProjectModal } from '@/components/Modal'

export default {
  name: 'WorkspaceLayout',
  mixins: [mixin],
  components: {
    PageLayout,
    HeadInfo,
    CreateProjectModal
  },
  data () {
    return {
      defaultAvatarImg: '@/assets/images/default-avatar.png'
    }
  },
  computed: {
    ...mapState({ basicInfo: state => state.user.basicInfo })
  }
}
</script>

<style lang="less" scoped>
.more-info {
  // min-width: 800px;
  .item {
    position: relative;
    text-align: left;
    padding: 0 32px 0 0;
    min-width: 125px;
    text-align: center;
    .num {
      font-size: 40px;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
      line-height: 56px;
    }
    .label {
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
    }
  }
}
.user-info {
  display: flex;
  margin-bottom: 12px;
  .avatar-wrapper {
    margin-right: 20px;
  }
  .info {
    padding-top: 7px;
    .name {
      font-size: 24px;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      margin-bottom: 22px;
    }
    .role {
    }
  }
}
</style>
